export default "__VITE_ASSET__CSqCj2UZ__"